import React from "react"
export const ShipmentLoadingDetailContext = React.createContext(null);

export const useShipmentLoadingDetailContext = () => {

    const context = React.useContext(ShipmentLoadingDetailContext);

if (!context) throw new Error("Shipment Loading Detail Context not provided!");

return context;
}